import cx from "classnames";
import { ComponentProps, forwardRef } from "react";

import styles from "style/pages/market/didFilterPage/components/input.module.scss";

type TInput = {} & ComponentProps<"input">;

const Input = forwardRef<HTMLInputElement, TInput>(function Input({ className, ...otherProps }: TInput, ref) {
  return <input className={cx(styles.input, className)} ref={ref} {...otherProps} />;
});

export default Input;
